var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex text-lg items-center justify-center w-8 h-8 absolute",class:[_vm.buttonColor, _vm.buttonAlignment],on:{"click":function($event){$event.preventDefault();return _vm.$emit('on-click')}}},[_c('IconXmark',{staticClass:"inline"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }